module.exports = __webpack_public_path__ + "img/li2.472fe28b.png";